export const PageAniList = {
  NONE: "",
  LEFT: "left",
  RIGHT: "right",
  FADE: "fade",
}

export const Themes = [
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
]

const initialState = {
  pageTitle: "Ray Virtual Smile",
  pageAni: PageAniList.NONE,
  show: {
    teams: false,
    password: false,
    teamsCheck: false,
    setting: false,
    synced: false,
    avatarPassword: false,
    unlink: false,
  },
  theme: "light",
  item: {},
};

export const AppConstant = {
  SET_APP: "APP_SET_APP",
  SET_PAGE_TITLE: "APP_SET_PAGE_TITLE",
  SET_PAGE_ANI: "APP_SET_PAGE_ANI",
  SET_SHOW_TEAMS: "APP_SET_SHOW_TEAMS",
  SET_SHOW_TEAMS_CHECK: "APP_SET_SHOW_TEAMS_CHECK",
  SET_SHOW_SETTING: "APP_SET_SHOW_SETTING",
  SET_SHOW_PASSWORD: "APP_SET_SHOW_PASSWORD",
  SET_SHOW_AVATAR_PASSWORD: "APP_SET_SHOW_AVATAR_PASSWORD",
  SET_SHOW_SYNCED: "APP_SET_SHOW_SYNCED",
  SET_SHOW_UNLINK: "APP_SET_SHOW_UNLINK",
  SET_CLEAR_ALL_SHOW: "APP_SET_CLEAR_ALL_SHOW",
  SET_THEME: "APP_SET_THEME",
};

export const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case AppConstant.SET_SHOW_UNLINK:
      return {
        ...state,
        show: {
          ...state.show,
          unlink: action.show,
        }
      }
    case AppConstant.SET_CLEAR_ALL_SHOW:
      const setClearAllShow = () => {
        const _show = {};
        for(const key of Object.keys(state?.show || {})) {
          _show[key] = false;
        }
        return _show;
      };
      return {
        ...state,
        show: setClearAllShow()
      }
    case AppConstant.SET_THEME:
      const theme = Themes.find(x => x.value === action.value);
      return {
        ...state,
        theme: theme?.value ?? "light",
      }
    case AppConstant.SET_SHOW_AVATAR_PASSWORD:
      return {
        ...state,
        show: {
          ...state.show,
          avatarPassword: action.show,
        }
      }
    case AppConstant.SET_SHOW_TEAMS_CHECK:
      return {
        ...state,
        show: {
          ...state.show,
          teamsCheck: action.show,
        }
      }
    case AppConstant.SET_SHOW_SYNCED:
      return {
        ...state,
        show: {
          ...state.show,
          synced: action.show,
        }
      }
    case AppConstant.SET_SHOW_PASSWORD:
      return {
        ...state,
        show: {
          ...state.show,
          password: action.show,
        }
      }
    case AppConstant.SET_SHOW_SETTING:
      return {
        ...state,
        show: {
          ...state.show,
          setting: action.show,
        }
      }
    case AppConstant.SET_SHOW_TEAMS:
      return {
        ...state,
        show: {
          ...state.show,
          teams: action.show,
        }
      }
    case AppConstant.SET_PAGE_ANI:
      return {
        ...state,
        pageAni: action.value
      };
    case AppConstant.SET_APP:
      return {
        ...state,
        item: action.item
      };
    case AppConstant.SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action?.title || initialState.pageTitle,
      }
    default:
      return state
  }
};
